// !DEPRICATED feb-05-2026
// import * as Tabs from '@radix-ui/react-tabs';
// import { FC, useState } from 'react';

// import { SegmentProps } from './segment.types';

// export const Segment: FC<SegmentProps> = ({ options, handleChange }) => {
//   //to set first object value as a default value
//   const [value, setValue] = useState(options[0].value);
//   return (
//     <Tabs.Root
//       className="rounded-custom1 bg-grey-10 flex w-fit flex-col p-1"
//       defaultValue={value}
//       onValueChange={(e) => {
//         setValue(e);
//         if (handleChange) {
//           handleChange(e);
//         }
//       }}
//     >
//       <Tabs.List className="flex shrink-0 gap-1 rounded-lg">
//         {options.map((tabValue, index) => (
//           <Tabs.Trigger
//             className="font-montserrat text-grey-50 data-[state=active]:text-dark-gray data-[state=active]:shadow-custom-light flex h-[28px] w-fit min-w-[79px] cursor-pointer items-center justify-center rounded-lg border-none bg-transparent p-2 text-xs  leading-none outline-none data-[state=active]:bg-white"
//             value={tabValue.value}
//             key={index}
//           >
//             <span style={{ fontWeight: 400 }}>{tabValue.label}</span>
//           </Tabs.Trigger>
//         ))}
//       </Tabs.List>
//     </Tabs.Root>
//   );
// };
import { FC, useState } from 'react';

import { SegmentProps } from './segment.types';

export const Segment: FC<SegmentProps> = ({ options, handleChange }) => {
  const [value, setValue] = useState(options[0].value);

  const handleClick = (nextValue: string) => {
    if (nextValue === value) return;
    setValue(nextValue);
    if (handleChange) {
      handleChange(nextValue);
    }
  };

  return (
    <div className="rounded-custom1 bg-grey-10 flex w-fit flex-row flex-nowrap gap-1 p-1">
      {options.map((tabValue) => {
        const isActive = value === tabValue.value;
        return (
          <button
            key={tabValue.value}
            type="button"
            onClick={() => handleClick(tabValue.value)}
            className={`font-montserrat flex h-[28px] min-w-[79px] cursor-pointer items-center justify-center rounded-lg border-none bg-transparent p-2 text-xs leading-none outline-none ${
              isActive ? 'text-dark-gray shadow-custom-light bg-white' : 'text-grey-50'
            }`}
          >
            <span className="font-normal">{tabValue.label}</span>
          </button>
        );
      })}
    </div>
  );
};
